import { render } from "./DateComponent.vue?vue&type=template&id=0bff1b90"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"

import "./DateComponent.vue?vue&type=style&index=0&id=0bff1b90&lang=scss"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__